/* global RadiantML */
/* global bowser */
/* global Silverlight */
/* global neonPlayer */

var NeonPlayerUtils = function () {
	var _literals = {
		playready: "playready",
		widevine: "widevine",
		silverlight: "silverlight-smooth-streaming",
		html5: "html5-mpeg-dash"
	};
	if (Object.freeze) {
		Object.freeze(_literals);
	}

	var checkWidevineLicenser = function (licenserUrl, callback) {
		var url = licenserUrl + "/Ping";
		var xhr = new XMLHttpRequest();
		xhr.onload = function () {
			callback(xhr.status == 200);
		};
		xhr.onabort = function () {
			callback(false);
		};
		xhr.onerror = function () {
			callback(false);
		};
		xhr.open("GET", url);
		xhr.send();
	};

	var checkDashManifest = function (url, callback) {
		var xhr = new XMLHttpRequest();
		xhr.onload = function () {
			callback(xhr.status == 200);
		};
		xhr.onabort = function () {
			callback(false);
		};
		xhr.onerror = function () {
			callback(false);
		};
		xhr.open("HEAD", url);
		xhr.send();
	};

	var getManifestUrl = function (baseUrl, mediaId, isTrailer) {
		var maxsubdirs = 500;
		var url = baseUrl ? baseUrl : "https://vod-dash.sfanytime.com/"; // Default PROD

		return url +
				(isTrailer ? "trailers/" : "features/") +
				(Math.floor(mediaId / maxsubdirs) * maxsubdirs) + "/" +
				mediaId + "/" + mediaId + ".ism/Manifest.mpd";
	};

	var getSmoothManifestUrl = function (baseUrl, mediaId, isTrailer) {
		var maxsubdirs = 500;
		var url = baseUrl ? baseUrl : "https://vod-smooth.sfanytime.com/"; // Default PROD

		return url +
				(isTrailer ? "trailers/" : "features/") +
				(Math.floor(mediaId / maxsubdirs) * maxsubdirs) + "/" +
				mediaId + "/" + mediaId + ".ism/Manifest";
	};

	var getSubtitleUrl = function (baseUrl, mediaId, isTrailer, language, format) {
		var maxsubdirs = 500;
		var url = baseUrl ? baseUrl : "https://vod-dash.sfanytime.com/"; // Default PROD
		format = typeof format !== "undefined" ? format : "vtt"; // Default vtt format
				
		// Hacky TODO extend so it supports any country code
		var threeLetterLanguage =   language == "sv" ? "swe" :
									language == "da" ? "dan" :
									language == "fi" ? "fin" :
									language == "no" ? "nor" : "";

		return url +
				(isTrailer ? "trailers/" : "features/") +
				(Math.floor(mediaId / maxsubdirs) * maxsubdirs) + "/" +
				mediaId + "/" + threeLetterLanguage + "." + format;
	};

	var getThumbnailsUrl = function (baseUrl, mediaId, isTrailer) {
		var maxsubdirs = 500;
		var url = baseUrl ? baseUrl : "https://vod-dash.sfanytime.com/"; // Default PROD

		return url +
				(isTrailer ? "trailers/" : "features/") +
				(Math.floor(mediaId / maxsubdirs) * maxsubdirs) + "/" +
				mediaId + "/" + mediaId + "_thumbs.json";
	};


	var _isDashSupported = function() {
		// Support is detected for DASH264 as explained here: http://www.radiantmedialyzer.net/documentation.html#mpeg-dash with the following modifications:
		// We check for M4A/AAC-LC instead of M4A/HE-AACv2 for audio
		var rml = new RadiantML();
		var mp4H264AAC = rml.mp4H264AAC("high40");
		var m4aAACLC = rml.m4aAACLC();
		var mse = rml.mse();
		if (mse && mp4H264AAC && m4aAACLC) {
			return true;
		} else {
			return false;
		}
	};

	var isEmeSupported = function() {
		var rml = new RadiantML();
		return rml.eme();
	};

	var getSupportedDrm = function() {
		// We would have prefered to do feature detection for widevine, but the firefox implementation has several problems with this, so we detect support based on browser instead
		if (bowser.chrome || (bowser.firefox && bowser.version >= 47)) { 
			// widevine supported by chrome and firefox 47 and up
			return _literals.widevine;
		}
		if ((bowser.msie || bowser.msedge) && window.MediaSource)  {
			// PlayReady supported in Edge and some versions of IE if running in windows 8.1 or higher
			return _literals.playready;
		}
		return "";
	};

	var _isNpapiSupported = function() {
		// NPAPI support is needed to run silverlight
		// Feature detecting NPAPI is quite complicated, so we are using browser detection instead
		// For now, from the major browsers only chrome 42 or higher lacks support
		if(bowser.chrome && bowser.version >= 42) {
			return false;
		} else {
			return true;
		}
	};

	var chooseInternalPlayer = function(isMediaEncrypted) {
		// return _literals.silverlight;
		// For more information, see documented diagram for internal player selection
		if(_isDashSupported()) {
			if(isMediaEncrypted) {
				if(isEmeSupported()) {
					if(getSupportedDrm()) {
						return _literals.html5;
					} else {
						return _isNpapiSupported() ? _literals.silverlight : "";
					}
				} else {
					return _isNpapiSupported() ? _literals.silverlight : "";
				}
			} else {
				return _literals.html5;
			}
		} else {
			return _isNpapiSupported() ? _literals.silverlight : "";
		}
	};
		
	var checkIfPlayabe = function(dashManifest, licenserUrl, isMediaEncrypted, callback) {
		
		var internalPlayer = chooseInternalPlayer(isMediaEncrypted);
		
		switch (internalPlayer) {
		case _literals.html5:
			// Even though the checks done here constitute an antipattern, integrations may expect them by now, so we leave them
			checkDashManifest(dashManifest, function(manifestAvailable) {
				if(manifestAvailable) {
					
					if(isMediaEncrypted && (getSupportedDrm() == _literals.widevine)) {
						
						checkWidevineLicenser(licenserUrl, function(licenserAvailable) {
							if(licenserAvailable) {
								callback({ canPlay: true, technology: "dash" });
							} else {
								callback( { canPlay: false, errorCode: 1002, error: "The licenser server is not available" } );
							}
						});
						
					} else {
						callback({ canPlay: true, technology: "dash" });
					}
					
				} else {
					callback( { canPlay: false, errorCode: 1003, error: "Dash manifest not available for this media" } );
				}
			});
			
			break;
		case _literals.silverlight:
			if(Silverlight.isInstalled("4.0.50917")) {
				callback({ canPlay: true, technology: "smooth" });
			} else {
				callback( { canPlay: false, errorCode: 1004, error: "Silverlight is not installed" } );
			}
			break;
		default:
			callback( { canPlay: false, errorCode: 1001, error: "Dash or SmoothStream technologies not available in this browser" } );
			break;
		}
	};

	var getMediaKeyId = function (manifestUrl, callback) {
		_fetchManifest(manifestUrl, _parseMediaKeyId, callback);
	};

	var _parseMediaKeyId = function (xhr, callback) {
		if (xhr === undefined) {
			callback("");
			return;
		}
		var kidMatch = xhr.responseText.match(/default_KID="([^"]*)"/);
		
		if(kidMatch && kidMatch.length > 1) {
			var kid = kidMatch[1];
			if (neonPlayer.getSettings().debug) window.console && console.log("NeonPlayerUtils.getMediaKeyID found: " + kid);
			callback(kid);
		} else {
			callback(null);
		}
	};

	var _fetchManifest = function (manifestUrl, parser, callback) {
		var xhr = new XMLHttpRequest();
		
		xhr.onload = function () {
			if (xhr.status == 200) {
				parser(xhr, callback);
			}
			else {
				window.console && console.error("XHR aborted. status is " + xhr.statusText + " (" + xhr.status + "), readyState is " + xhr.readyState);
				parser(undefined, callback);
			}
		};
		
		xhr.onabort = function () {
			window.console && console.error("XHR aborted. status is " + xhr.statusText + " (" + xhr.status + "), readyState is " + xhr.readyState);
			parser(undefined, callback);
		};
		
		xhr.onerror = function () {
			window.console && console.error("XHR error. status is " + xhr.statusText + " (" + xhr.status + "), readyState is " + xhr.readyState);
			parser(undefined, callback);
		};

		xhr.open("GET", manifestUrl);
		xhr.send();
	};

	return {
		checkDashManifest: checkDashManifest,
		checkWidevineLicenser: checkWidevineLicenser,
		checkIfPlayabe: checkIfPlayabe,
		getManifestUrl: getManifestUrl,
		getSmoothManifestUrl: getSmoothManifestUrl,
		getSubtitleUrl: getSubtitleUrl,
		getThumbnailsUrl: getThumbnailsUrl,
		getSupportedDrm: getSupportedDrm,
		chooseInternalPlayer: chooseInternalPlayer,
		getMediaKeyId: getMediaKeyId,
		getLiterals: function() {
			return _literals;
		}
	};
}();







